import PublicRoutes from "./public/PublicRoutes";

const Routing = () => {
    return (
        <PublicRoutes />
    )
}

export default Routing;